import 'core-js/stable';
import 'regenerator-runtime/runtime';

__webpack_public_path__ = window.environment?.cdnHost || __webpack_public_path__; // eslint-disable-line no-undef
